import { Channels } from "@website/utils/channel/types";
import LOGO_B2B from "@website/widget-v2/header/assets/logo-b2b.svg";
import LOGO_MINIMAL from "@website/widget-v2/header/assets/logo-minimal.svg";
import LOGO from "@website/widget-v2/header/assets/logo.png";
import LOGO_SHAB from "@website/widget-v2/header/assets/logo_shab.svg";
import LOGO_SNAPP from "@website/widget-v2/header/assets/logo_snapp.svg";
import { StaticImageData } from "next/image";

type LogoChannels = Extract<Channels, "snapp-ir" | "b2b" | "shab">;

export const logoSchema: Record<
  LogoChannels | "default" | "minimal",
  {
    label: string;
    image: string | StaticImageData;
    title: string;
    width?: number;
    height?: number;
  }
> = {
  "snapp-ir": {
    label: "snapp",
    image: LOGO_SNAPP,
    title: "اسنپ"
  },
  b2b: {
    label: "snapptrip",
    image: LOGO_B2B,
    title: "اسنپ تریپ"
  },
  shab: {
    label: "shab",
    image: LOGO_SHAB,
    width: 124,
    height: 66,
    title: "شب"
  },
  default: {
    label: "snapptrip",
    image: LOGO,
    title: "اسنپ تریپ"
  },
  minimal: {
    label: "snapptrip",
    image: LOGO_MINIMAL,
    title: "اسنپ تریپ"
  }
};
